import { getMoreToolbarElement } from './GetMoreToolbarElement';

export const getMoreToolbarStartAndEndButtons = ({
  startButtonDataHook,
  endButton,
}: {
  startButtonDataHook: string;
  endButton: HTMLButtonElement | string;
}) => {
  const startButton = getMoreToolbarElement(startButtonDataHook);

  return {
    start: startButton,
    end: typeof endButton === 'string' ? getMoreToolbarElement(endButton) : endButton,
  };
};
